import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-turbo-tax-offline',
  templateUrl: './turbo-tax-offline.component.html',
  styleUrls: ['./turbo-tax-offline.component.scss']
})
export class TurboTaxOfflineComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
